import React from "react";
import PropTypes from "prop-types";
import Svg from "_assets/svg";
import Input from "./Input";
import SearchIcon from "./SearchIcon";
import Wrapper from "./Wrapper";

const Search = (props) => {
  const { placeholder, className, onSearch } = props;
  return (
    <Wrapper className={className}>
      <Input
        placeholder={placeholder}
        onChange={(e) => onSearch(e.target.value?.toLowerCase()?.trim())}
      />
      <SearchIcon src={Svg.search.default} alt="search" />
    </Wrapper>
  );
};

Search.propTypes = {
  placeholder: PropTypes.string,
  className: PropTypes.string,
};

Search.defaultProps = {
  placeholder: "",
  className: "",
};

export default Search;
